const LOCAL_PORT_BLOCK_SIZE = 1000;

// O actuar-app legado vive noutro repositório, não sobe junto com este monorepo
// e só existe em produção — daí não ter porta local nem host por ambiente.
const LEGACY_APP_LOCAL_URL = 'https://app.actuar.com';

// O Pague.lá v2 vive noutro repositório e tem uma única publicação: não sobe
// junto com este monorepo, daí não ter porta local.
const PAGUELA_V2_APP_LOCAL_URL = 'https://novo.pague.la';

const LOCAL_APP_BASE_PORTS = {
  accounts: 4800,
  actuar_app: 4900,
  treino_app: 4400,
  actuar_sign: 4500,
  afig_app: 4600,
  actuar_acesso: 4700,
  actuar_mobile: 4200,
  facilfit_app: 4900,
  face_detection_app: 4300,
  ediz_app: 4900,
  tickou_app: 4900,
  live_pickup_app: 4700,
  // Same port as `actuar_mobile`: `nx serve ediz-family-mobile-app` binds 4200.
  ediz_family_app: 4200,
  // `nx serve access-remote-control-app`. Era 4600, a mesma do afig: os dois não
  // subiam juntos, e o link de um caía no outro.
  live_access_app: 4100,
};

function isLocalHostname(hostname: string): boolean {
  return (
    hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '[::1]'
  );
}

function getCurrentLocalHostname(): string {
  if (typeof window === 'undefined') {
    return 'localhost';
  }

  return isLocalHostname(window.location.hostname)
    ? window.location.hostname
    : 'localhost';
}

function getCurrentLocalPortOffset(): number {
  if (
    typeof window === 'undefined' ||
    !isLocalHostname(window.location.hostname)
  ) {
    return 0;
  }

  const currentPort = Number(window.location.port);
  if (!Number.isInteger(currentPort)) {
    return 0;
  }

  const uniqueBasePorts = [...new Set(Object.values(LOCAL_APP_BASE_PORTS))];
  const matchedOffset = uniqueBasePorts.find((basePort) => {
    const delta = currentPort - basePort;
    return delta >= 0 && delta % LOCAL_PORT_BLOCK_SIZE === 0;
  });

  return matchedOffset === undefined ? 0 : currentPort - matchedOffset;
}

function buildLocalUrl(hostname: string, port: number): string {
  return `http://${hostname}:${port}`;
}

export function buildLocalAppUrl() {
  const hostname = getCurrentLocalHostname();
  const offset = getCurrentLocalPortOffset();

  return {
    accounts: buildLocalUrl(hostname, LOCAL_APP_BASE_PORTS.accounts + offset),
    actuar_app: buildLocalUrl(
      hostname,
      LOCAL_APP_BASE_PORTS.actuar_app + offset
    ),
    legacy_app: LEGACY_APP_LOCAL_URL,
    treino_app: buildLocalUrl(
      hostname,
      LOCAL_APP_BASE_PORTS.treino_app + offset
    ),
    actuar_sign: buildLocalUrl(
      hostname,
      LOCAL_APP_BASE_PORTS.actuar_sign + offset
    ),
    afig_app: buildLocalUrl(hostname, LOCAL_APP_BASE_PORTS.afig_app + offset),
    actuar_acesso: buildLocalUrl(
      hostname,
      LOCAL_APP_BASE_PORTS.actuar_acesso + offset
    ),
    actuar_mobile: buildLocalUrl(
      hostname,
      LOCAL_APP_BASE_PORTS.actuar_mobile + offset
    ),
    facilfit_app: buildLocalUrl(
      hostname,
      LOCAL_APP_BASE_PORTS.facilfit_app + offset
    ),
    face_detection_app: buildLocalUrl(
      hostname,
      LOCAL_APP_BASE_PORTS.face_detection_app + offset
    ),
    ediz_app: buildLocalUrl(hostname, LOCAL_APP_BASE_PORTS.ediz_app + offset),
    tickou_app: buildLocalUrl(
      hostname,
      LOCAL_APP_BASE_PORTS.tickou_app + offset
    ),
    live_pickup_app: buildLocalUrl(
      hostname,
      LOCAL_APP_BASE_PORTS.live_pickup_app + offset
    ),
    ediz_family_app: buildLocalUrl(
      hostname,
      LOCAL_APP_BASE_PORTS.ediz_family_app + offset
    ),
    live_access_app: buildLocalUrl(
      hostname,
      LOCAL_APP_BASE_PORTS.live_access_app + offset
    ),
    paguela_v2_app: PAGUELA_V2_APP_LOCAL_URL,
  };
}
